import { BrowserModule } 						from '@angular/platform-browser';
import { NgModule, CUSTOM_ELEMENTS_SCHEMA } 	from '@angular/core';

import { AppRoutingModule } 					from './app-routing.module';
import { AppComponent } 						from './app.component';
import { MatFormFieldModule } 					from '@angular/material/form-field';
import { MatInputModule } 						from '@angular/material/input';
import { MatButtonModule } 						from '@angular/material/button';
import { MatTableModule } 						from '@angular/material/table';
import { MatDialogModule } 						from '@angular/material/dialog';
import { MatIconModule } 						from '@angular/material/icon';
import { MatSelectModule } 						from '@angular/material/select';
import { MatCheckboxModule } 					from '@angular/material/checkbox';
import { MatMenuModule } 						from '@angular/material/menu';
import { MatTooltipModule } 					from '@angular/material/tooltip';
import { BrowserAnimationsModule } 				from '@angular/platform-browser/animations';
import { ReactiveFormsModule, FormsModule } 	from '@angular/forms';
import { LoginComponent } 						from './login/login.component';
import { LoginService } 						from './login/login.service';
import { MatRadioModule } 						from '@angular/material/radio';
import { HttpClientModule, HTTP_INTERCEPTORS } 	from '@angular/common/http';
import { APP_BASE_HREF } 	from '@angular/common/';
import {
	SocialLoginModule,
	SocialAuthServiceConfig,
	GoogleLoginProvider
} 												from 'angularx-social-login';
import { environment } 							from 'src/environments/environment';
import { CreateActionList, HeaderComponent } 	from './header/header.component';
import { DashboardComponent } 					from './dashboard/dashboard.component';
import { FormComponent } 						from './form/form.component';
import { FormbuilderService } 					from './services/formbuilder.service';
import { RedirectComponent } 					from './redirect/redirect.component';
import { HttpInterceptorService } 				from './authentication/http-interceptor.service';
import { AuthService } 							from "./services/auth.service";
import { CookieService } 						from "ngx-cookie-service";
import { FormService } 							from './form/form.service';
import { DashboardService } 					from './dashboard/dashboard.service';
import { SortformsComponent } 					from './sortforms/sortforms.component';
import { AddNewItemToFormComponent } 			from '../app/form/add-new-item/add-new-item-to-form.component';
import { FieldPropertiesComponent } 			from '../app/form/field-properties/field-properties.component';
import { TopicItemsComponent } 					from './form/topic-items/topic-items.component';
import { CancelConfirmationComponent } 			from './form/cancel-confirmation/cancel-confirmation.component';
import { LoaderService } 						from "./services/loader.service";
import { SettingsComponent } 					from './settings/settings.component';
import { SortTopicsComponent } 					from './sort-topics/sort-topics.component';
import { SubmittedFormDetailsComponent } 		from './submitted-form-details/submitted-form-details.component';
import { FormPreviewComponent } 				from './form-preview/form-preview.component';
import { AddNewTopicsComponent } 				from './add-new-topics/add-new-topics.component';
import { LogoutConfirmationComponent } 			from './header/logout-confirmation/logout-confirmation.component';
import { ValidationPopupComponent } 			from './form/validation-popup/validation-popup.component';
import { LightboxModule } 						from 'ngx-lightbox';
import { PasswordModalComponent } 				from './password-modal/password-modal.component';
import { SharedService } 						from "./services/shared.service";
import { PdfViewerModalComponent } 				from "./pdf-viewer-modal/pdf-viewer-modal.component";
import { CloneTemplateComponent } 				from "./sortforms/clone-template/clone-template.component";
import { MatSnackBarModule } 					from '@angular/material/snack-bar';
import { CompletedFormsComponent } 				from './completed-forms/completed-forms.component';
import { TrashComponent } 						from './trash/trash.component';
import { MatSortModule } 						from '@angular/material/sort';
import { CreateFormComponent } 					from './create-form/create-form.component';
import { MatSlideToggleModule } 				from '@angular/material/slide-toggle';
import { DragDropModule } 						from '@angular/cdk/drag-drop';
import { ActionListArchivedComponent }		    from  './dashboard/action-list-archived/action-list-archived.component';
import { RestoreArchivedItemsComponent } 		from "./dashboard/restore-archived-items/restore-archived-items.component";
import { CcEmailAndSmsComponent } 				from "./dashboard/cc-email-and-sms/cc-email-and-sms.component";
import { ConfimationModalComponent } 			from './confimation-modal/confimation-modal.component';
import { ActionlistTrashComponent } 			from './actionlist-trash/actionlist-trash.component';
import { ActionListOrderComponent } 			from './action-list-order/action-list-order.component';
import { ShowOriginalDetailsComponent } 		from './show-original-details/show-original-details.component';
import { ExportActionListComponent } 			from './export-action-list/export-action-list.component';
import { AccountComponent } 					from './account/account.component';
import { TutorialVideosComponent } 				from './tutorial-videos/tutorial-videos.component';
import { ProfileComponent } 					from './profile/profile.component';
import { HelpComponent } 						from './help/help.component';
import { AddNewTopicComponent } 				from './form/add-new-topic/add-new-topic.component';
import { ThemeComponent } 						from './theme/theme.component';
import { PageNotFoundComponent } from './page-not-found/page-not-found.component';
import { FlaggedFormsComponent } from './flagged-forms/flagged-forms.component';
import { FileCabinetComponent } from './file-cabinet/file-cabinet.component';
import { HelpFaqComponent } from './help-faq/help-faq.component';
import {MatExpansionModule} from '@angular/material/expansion';
import {MatChipsModule} from '@angular/material/chips';
import { HelpFormsComponent } from './help-forms/help-forms.component'
import { ElementInfoPopupComponent } from "./form/element-info-popup/element-info-popup.comoponent";
import { TemplatePreviewComponent } from './form/template-preview/template-preview.component';
import { FormErrorsGuard } from './services/formerrors.guard';
import { OwlDateTimeModule } from '@danielmoncada/angular-datetime-picker';
import { TeamSelectionComponent } from './team-selection/team-selection.component';
import { SignupComponent } from './signup/signup.component';
import { WindowReferenceService } from './window-reference.service';
import { PaymentsComponent } from './payments/payments.component';
import { OwlMomentDateTimeModule } from '@danielmoncada/angular-datetime-picker-moment-adapter';
import { SubscriptionPlansComponent } from './subscription-plans/subscription-plans.component';
import { ConfigurationNewComponent } from './settings/configuration-new/configuration-new.component';
import { ConfigurationComponent } from './settings/configuration/configuration.component';
// import { AddNewCardComponent } from './add-new-card/add-new-card.component';
import { SubscriptionCancelConfirmationComponent } from './subscription-cancel-confirmation/subscription-cancel-confirmation.component';
import { OrganizationsComponent } from './organizations/organizations.component';
import { CloneTemplateOrganizationComponent } from './sortforms/clone-template-organization/clone-template-organization.component';
import { SubscriptonHistoryComponent } from './subscripton-history/subscripton-history.component';
import { OrganizationFormsComponent } from './organization-forms/organization-forms.component';
import { ResetPasswordComponent } from './reset-password/reset-password.component';
import { ChangePasswordComponent } from './change-password/change-password.component';


@NgModule({
	declarations: [
		AppComponent,
		LoginComponent,
		HeaderComponent,
		DashboardComponent,
		CreateActionList,
		FormComponent,
		RedirectComponent,
		SortformsComponent,
		// AddNewItemToFormComponent,
		FieldPropertiesComponent,
		TopicItemsComponent,
		CancelConfirmationComponent,
		LogoutConfirmationComponent,
		ValidationPopupComponent,
		SettingsComponent,
		SortTopicsComponent,
		SubmittedFormDetailsComponent,
		FormPreviewComponent,
		AddNewTopicsComponent,
		PasswordModalComponent,
      	PdfViewerModalComponent,
		CloneTemplateComponent,
		CompletedFormsComponent,
		TrashComponent,
      	CreateFormComponent,
		ActionListArchivedComponent,
		RestoreArchivedItemsComponent,
		CcEmailAndSmsComponent,
		ConfimationModalComponent,
		ActionlistTrashComponent,
		ActionListOrderComponent,
		ShowOriginalDetailsComponent,
		ExportActionListComponent,
		AccountComponent,
		TutorialVideosComponent,
		ProfileComponent,
		HelpComponent,
		AddNewTopicComponent,
      	ThemeComponent,
      	PageNotFoundComponent,
      	FlaggedFormsComponent,
      	FileCabinetComponent,
      	HelpFaqComponent,
      	HelpFormsComponent,
		ElementInfoPopupComponent,
		TemplatePreviewComponent,
		TeamSelectionComponent,
		SignupComponent,
		PaymentsComponent,
		SubscriptionPlansComponent,
		ConfigurationNewComponent,
		// AddNewCardComponent,
		SubscriptionCancelConfirmationComponent,
		ConfigurationComponent,
		OrganizationsComponent,
		CloneTemplateOrganizationComponent,
		SubscriptonHistoryComponent,
		OrganizationFormsComponent,
		ResetPasswordComponent,
		ChangePasswordComponent
   ],
	imports: [
		BrowserModule,
		AppRoutingModule,
		MatFormFieldModule,
		BrowserAnimationsModule,
		ReactiveFormsModule,
		FormsModule,
		HttpClientModule,
		MatInputModule,
		MatButtonModule,
		MatIconModule,
		MatTableModule,
		MatSelectModule,
		MatCheckboxModule,
		MatDialogModule,
		MatMenuModule,
		MatTooltipModule,
		MatSlideToggleModule,
		SocialLoginModule,
		LightboxModule,
		MatRadioModule,
		MatSnackBarModule,
		MatSortModule,
		MatExpansionModule,
		DragDropModule,
		MatChipsModule,
		OwlDateTimeModule,
		OwlMomentDateTimeModule
	],
	providers: [
		{ provide: OwlDateTimeModule, useClass: OwlMomentDateTimeModule },
		{ provide: APP_BASE_HREF, useValue: window['_app_base'] || '/' },
		{
			provide: 'SocialAuthServiceConfig',
			useValue: {
				autoLogin: false,
				providers: [
					{
						id: GoogleLoginProvider.PROVIDER_ID,
						provider: new GoogleLoginProvider(
							environment.google_client_id
						)
					}
				]
			} as SocialAuthServiceConfig,
		},
		HttpInterceptorService,
		{
			provide: HTTP_INTERCEPTORS,
			useClass: HttpInterceptorService,
			multi: true
		},
		FormErrorsGuard,
		LoginService,
		FormbuilderService,
		AuthService,
		CookieService,
		FormService,
		DashboardService,
		LoaderService,
		SharedService,
		ProfileComponent,
		AddNewItemToFormComponent,
		WindowReferenceService
	],
	entryComponents: [
		AppComponent,
		CreateActionList,
		// AddNewItemToFormComponent,
		FieldPropertiesComponent,
		TopicItemsComponent,
		CancelConfirmationComponent,
		LogoutConfirmationComponent,
		PasswordModalComponent,
		ValidationPopupComponent,
		PdfViewerModalComponent,
		CloneTemplateComponent,
		CcEmailAndSmsComponent,
		ShowOriginalDetailsComponent,
		AddNewTopicComponent,
		ElementInfoPopupComponent,
		ResetPasswordComponent,
		ChangePasswordComponent
	],
	bootstrap: [AppComponent],
	schemas: [ CUSTOM_ELEMENTS_SCHEMA ]
})
export class AppModule { }
